import * as THREE from "three";
import { ParticleSystem } from "@engine";

const CAPACITY = 256;

// Game-side preset bursts on top of the engine's reusable ParticleSystem.
// The emitter is added directly to scene.scene (not worldGroup) so that
// sparks stay world-locked at the burst position regardless of the world
// rotation/scroll. Three preset bursts: graze, gate, death.
export class Sparks {
  private system = new ParticleSystem({ capacity: CAPACITY });

  attach(scene: THREE.Scene): void {
    scene.add(this.system.object);
  }

  burstAt(pos: THREE.Vector3, color: number, count = 8): void {
    this.system.emit({
      origin: pos,
      count,
      color,
      speed: { min: 1.5, max: 4.5 },
      spread: Math.PI,
      lifetime: { min: 0.25, max: 0.55 },
      size: { min: 0.04, max: 0.1 },
      gravity: 6,
      drag: 1.2,
    });
  }

  gateBurst(centerWorldPos: THREE.Vector3, color: number): void {
    this.system.emit({
      origin: centerWorldPos,
      count: 36,
      color,
      speed: { min: 4, max: 9 },
      spread: Math.PI,
      lifetime: { min: 0.5, max: 0.9 },
      size: { min: 0.05, max: 0.14 },
      gravity: 0,
      drag: 0.8,
    });
  }

  deathBurst(pos: THREE.Vector3): void {
    this.system.emit({
      origin: pos,
      count: 80,
      color: 0xff4554,
      speed: { min: 6, max: 14 },
      spread: Math.PI,
      lifetime: { min: 0.6, max: 1.2 },
      size: { min: 0.06, max: 0.16 },
      gravity: 12,
      drag: 0.6,
    });
  }

  update(dt: number): void {
    this.system.update(dt);
  }

  dispose(): void {
    this.system.dispose();
  }
}
